<script lang="ts" setup>
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import emblaCarouselVue from 'embla-carousel-vue'
const [emblaRef, emblaApi] = emblaCarouselVue({ align: 'start' }, [WheelGesturesPlugin()])

type MediaCard = {
  title: string
  text: string
  media: Record<string, unknown>
}

type Props = {
  title: string
  mediaCards: MediaCard[]
}

const _props = defineProps<{ data: Props; theme: string | null | undefined }>()

const activeIndex = ref(0)

const state = ref({
  canScrollPrev: false,
  canScrollNext: true,
})

onMounted(() => {
  if (emblaApi.value) {
    const togglePrevNextBtnsState = () => {
      state.value.canScrollPrev = emblaApi.value?.canScrollPrev() || false
      state.value.canScrollNext = emblaApi.value?.canScrollNext() || false
      activeIndex.value = emblaApi.value?.selectedScrollSnap() || 0 // Update activeIndex
    }

    emblaApi.value
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  }
})
</script>

<template>
  <div class="relative text-(--theme-fg)">
    <div class="mx-bleed relative border-t border-(--theme-fg)/15" />
    <h2 v-if="data.title" class="ml-bleed my-8 text-sm font-bold uppercase">{{ data.title }}</h2>
    <div class="carousel mt-10 w-full lg:mt-8">
      <div class="px-bleed mb-6 hidden justify-end gap-(--grid-gap) lg:flex">
        <button
          class="cursor-pointer"
          :class="{ 'opacity-30': !state.canScrollPrev }"
          :disabled="!state.canScrollPrev"
          aria-label="Previous slide"
          @click="() => emblaApi?.scrollPrev()"
        >
          <IconsArrowLeft class="size-5" />
        </button>

        <button
          class="cursor-pointer"
          :class="{ 'opacity-30': !state.canScrollNext }"
          :disabled="!state.canScrollNext"
          aria-label="Next slide"
          @click="() => emblaApi?.scrollNext()"
        >
          <IconsArrowRight class="size-5" />
        </button>
      </div>
      <div ref="emblaRef" class="embla documents pl-bleed pr-bleed">
        <div class="embla__container">
          <div
            v-for="(media, index) in data.mediaCards"
            :key="index"
            class="embla__slide lg:w-cols-6"
          >
            <CardsMedia v-bind="media" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.embla {
  overflow: hidden;
}
.embla__container {
  display: flex;
  gap: var(--grid-gap);
}
.embla__slide {
  flex: 0 0 calc(var(--cols-4) - var(--grid-bleed));
  @media (min-width: 900px) {
    flex: 0 0 var(--cols-6);
  }
  min-width: 0;
}

/*.push-left {
  @media (min-width: 900px) {
    padding-left: calc(var(--push-3) + var(--grid-bleed));
  } 
}*/
</style>
